<template>
  <v-dialog :value="value" :width="500" persistent scrollable>
    <v-card>
      <v-card-title class="justify-space-between">
        <div class="headline">Broadcast history</div>
        <v-btn flat icon left @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card v-if="errorData">
          <v-card-text class="caption">
            <div
              :style="{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 5,
                overflow: 'hidden'
              }"
            >
              {{ errorData.message }}
            </div>
          </v-card-text>
        </v-card>
        <p class="mb-0 mt-3">{{ $t('total_users') }}: {{ total }}</p>
        <v-data-table
          :headers="headers"
          :items="items"
          :total-items="total"
          :pagination.sync="pagination"
          :rows-per-page-items="[10, 25, 50]"
          :loading="loading"
          class="mt-3"
          :style="{ marginLeft: '-16px', marginRight: '-16px' }"
        >
          <template #items="{ item }">
            <td>{{ `${item.first_name || ''} ${item.last_name || ''}`.trim() }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import broadcastApi from '@/api/broadcast'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    broadcast: {
      type: Object,
      default: undefined
    },
    app: {
      type: String,
      default: 'facebook'
    },
    errorData: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      headers: [
        {
          value: 'name',
          text: this.$t('name'),
          sortable: false
        }
      ],
      loading: true,
      items: [],
      total: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      }
    }
  },
  watch: {
    pagination() {
      this.fetchItems()
    }
  },
  methods: {
    async fetchItems() {
      if (!this.errorData) return

      try {
        this.loading = true

        const response = await broadcastApi.getBroadcastLogs({
          page_id: this.broadcast.pageid,
          broadcast_id: this.broadcast.id,
          app: this.app,
          limit: this.pagination.rowsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          resultmessage: {
            facebook: this.errorData.message,
            line: this.errorData.message.replaceAll('"', '\\"')
          }[this.app]
        })
        if (response.status === 200) {
          const { data, total } = response.data
          this.items = data
          this.total = total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastHistory/UserListDialog.vue